import { Injectable, EventEmitter, Inject } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { SessionService } from './session.service';
import { map, catchError } from 'rxjs/operators';
import { CommonService } from './common.service';
import { AppConfig } from '@tech-utils/app-config.service';
import { DOCUMENT } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import {
  ProfileportfolioService as sdkService,
  FixedperiodsInterfece,
  PortfolioDataInterface,
  PortfolioanalysisSumaryInterface,
  PortfolioanalysisPositionsInterface,
  PortfolioanalysisTradesInterface,
  PortfolioInterface,
  CompletedataService,
  PortfolioanalysisCreditsInterface,
} from '@techrules/portallib';
import { ModalCashinComponent } from '../../areas/main/profileportfolio/modal-cashin/modal-cashin.component';
import { TechModalDialogComponent } from '../../shared/techmodaldialog/techmodaldialog.component';
import { TechModalDialogResendComponent } from '../../shared/techmodaldialogresend/techmodaldialogresend.component';
import { TechModalDialogResendModel } from '../../shared/techmodaldialogresend/techmodaldialogresend.model';
import { DomainEnum } from '@tech-utils/utils';

@Injectable({
  providedIn: 'root',
})
export class ProfileportfolioService {
  private portfolioCode: string;
  loadingRiskValuations: boolean = true;
  portfolioanalysisPositions: PortfolioanalysisPositionsInterface;

  // Behavior Subjects
  portfolioDataSource = new BehaviorSubject<PortfolioDataInterface>({} as any);
  portfolioData$ = this.portfolioDataSource.asObservable();

  portfolioanalysisSource =
    new BehaviorSubject<PortfolioanalysisSumaryInterface>({} as any);
  portfolioanalysis$ = this.portfolioanalysisSource.asObservable();

  periodSelectedSource = new BehaviorSubject<FixedperiodsInterfece>({} as any);
  periodSelected$ = this.periodSelectedSource.asObservable();

  porfolionameSource = new BehaviorSubject<string>('');
  portfolioname$ = this.porfolionameSource.asObservable();

  portfolioanalysisTradesSource = new BehaviorSubject<
    PortfolioanalysisTradesInterface[]
  >([] as any);
  portfolioanalysisTrades$ = this.portfolioanalysisTradesSource.asObservable();

  portfolioanalysisCreditsSource = new BehaviorSubject<
    PortfolioanalysisCreditsInterface[]
  >({} as any);
  portfolioanalysisCredits$ =
    this.portfolioanalysisCreditsSource.asObservable();

  portfolioAnalysisHasCreditsSource = new BehaviorSubject<boolean>({} as any);
  portfolioAnalysisHasCredits$ =
    this.portfolioAnalysisHasCreditsSource.asObservable();
  portfolioGoCashInSource = new BehaviorSubject<PortfolioDataInterface>(
    {} as any
  );
  portfolioGoCashIn$ = this.portfolioGoCashInSource.asObservable();
  // Event Emitters
  fixedPeriods$ = new EventEmitter<[FixedperiodsInterfece]>();
  portfolioPdfUrlReport$ = new EventEmitter<string>();
  portfolioanalysisPositions$ =
    new EventEmitter<PortfolioanalysisPositionsInterface>();
  showPeriodDiscretePerformaceSource = new BehaviorSubject<boolean>(false);
  showPeriodDiscretePerformace$ = this.showPeriodDiscretePerformaceSource.asObservable();  
  periodDiscretePerformaceSource = new BehaviorSubject<FixedperiodsInterfece>({Name:"Annual", Period:"Annual"});
  periodDiscretePerformace$ = this.periodDiscretePerformaceSource.asObservable();


  constructor(
    private session: SessionService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private translate: TranslateService,
    private sdkSvc: sdkService,
    private completedataService: CompletedataService,
    @Inject(DOCUMENT) private document: any
  ) {}

  getPortfolios(): Observable<[PortfolioInterface]> {
    return this.sdkSvc.getPortfolios(localStorage.getItem('ClientId')).pipe(
      map((res: any) => {
        //this.session.sessionToken = res.headers.get('tower30-sessiontoken');
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        //comprobamos que el OnboardingStatus no esta en PRODUCTIVE y el OnboardingStep
        //por si estuviera en alguna parte del Onboarding para redireccionarlo a si debido sitio
        let portfolioCode: string = '';
        let modelPortfolioCode: string = '';
        let isProductive: boolean = true;
        let goCashIn: boolean = false;
        let step: string = '99';

        for (let portfolio of res.ClientPortfolios) {
          if (
            portfolio.OnboardingStatus !== '' &&
            portfolio.OnboardingStatus !== 'PRODUCTIVE' &&
            portfolio.OnboardingStatus !== 'ACTIVE'
          ) {
            isProductive = false;
            if (step > portfolio.OnboardingStep) {
              step = portfolio.OnboardingStep;
              portfolioCode = portfolio.PortfolioCode;
              modelPortfolioCode = portfolio.ModelPortfolioCode;
            }
          } else if (
            portfolio.OnboardingStatus == 'ACTIVE' &&
            this.commonService.clientDataInitialSource.getValue()
              .OnboardingStatus == 'CLIENT' &&
            this.session.domain === DomainEnum.BULLTICK
          ) {
            goCashIn = true;
            this.portfolioGoCashInSource.next(portfolio);
          }
        }
        this.commonService.isProductiveSource.next(isProductive);
        if (
          !isProductive &&
          localStorage.getItem('OnboardingType') == 'Linear'
        ) {
          localStorage.setItem('Step', step);
          localStorage.setItem('portfolioCode', portfolioCode);
          this.goToRedirectToStep(step);
        } else if (
          isProductive &&
          localStorage.getItem('OnboardingType') == 'Linear' &&
          res.ClientPortfolios.length == 1 &&
          !AppConfig.settings.favoritesOnDashboard
        ) {
          this.commonService.portfolioCodeSource.next(
            res.ClientPortfolios[0].PortfolioCode
          );
          localStorage.setItem(
            'PortfolioCode',
            res.ClientPortfolios[0].PortfolioCode
          );
          this.router.navigate(['/profileportfolio']);
        } else if (goCashIn) {
          this.loadModalGoCashIn();
        } else {
          this.commonService.stepOKSource.next(true);
        }

        return res.ClientPortfolios;
      }),
      catchError((err) => {
        this.router.navigate(['/login']);
        return throwError(err);
      })
    );
  }

  // TODO: ÑAPA para questionario, hay que analizarlo y quitar, no hay que poner router en los servicios.
  getPortfolios2(): Observable<[PortfolioInterface]> {
    return this.sdkSvc.getPortfolios(localStorage.getItem('ClientId')).pipe(
      map((res: any) => {
        //this.session.sessionToken = res.headers.get('tower30-sessiontoken');
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        //comprobamos que el OnboardingStatus no esta en PRODUCTIVE y el OnboardingStep
        //por si estuviera en alguna parte del Onboarding para redireccionarlo a si debido sitio
        let portfolioCode: string = '';
        let modelPortfolioCode: string = '';
        let isProductive: boolean = true;
        let goCashIn: boolean = false;
        let step: string = '99';

        for (let portfolio of res.ClientPortfolios) {
          if (
            portfolio.OnboardingStatus !== '' &&
            portfolio.OnboardingStatus !== 'PRODUCTIVE' &&
            portfolio.OnboardingStatus !== 'ACTIVE'
          ) {
            isProductive = false;
            if (step > portfolio.OnboardingStep) {
              step = portfolio.OnboardingStep;
              portfolioCode = portfolio.PortfolioCode;
              modelPortfolioCode = portfolio.ModelPortfolioCode;
            }
          } else if (
            portfolio.OnboardingStatus == 'ACTIVE' &&
            this.commonService.clientDataInitialSource.getValue()
              .OnboardingStatus == 'CLIENT' &&
            this.session.domain === DomainEnum.BULLTICK
          ) {
            goCashIn = true;
            this.portfolioGoCashInSource.next(portfolio);
          }
        }
        this.commonService.isProductiveSource.next(isProductive);
        if (
          !isProductive &&
          localStorage.getItem('OnboardingType') == 'Linear'
        ) {
          localStorage.setItem('Step', step);
          localStorage.setItem('portfolioCode', portfolioCode);
          this.goToRedirectToStep(step);
        } else if (goCashIn) {
          this.loadModalGoCashIn();
        } else {
          this.commonService.stepOKSource.next(true);
        }

        return res.ClientPortfolios;
      }),
      catchError((err) => {
        this.router.navigate(['/login']);
        return throwError(err);
      })
    );
  }

  private goToRedirectToStep(step): void {
    let dialogData = new TechModalDialogResendModel();
    let dialogRef: any;

    switch (step) {
      case '4.v':
        this.document.location.href = AppConfig.settings.base + '/step/' + step;
        break;
      case '4.e':
        this.document.location.href = AppConfig.settings.base + '/step/' + step;
        break;
      default:
        const stepInt = parseInt(step);
        switch (stepInt) {
          case 2: //Test
            this.session.operativeInit = 'signup';
            this.router.navigate(['/questionnaire']);
            break;
          case 3: //InitialAmount
            this.document.location.href =
              AppConfig.settings.base + '/step/' + step;
            break;
          case 4: //Datos Completos
            this.document.location.href =
              AppConfig.settings.base + '/step/' + step;
            break;
          case 7:
          case 5: //Proceso de validacion
            this.commonService.loading$.emit(false);
            this.translate.get('k002184').subscribe((text) => {
              dialogData.title = '<center>' + text + '</center>'; //Token: Registro en validación
            });
            this.translate.get('k002185').subscribe((text) => {
              dialogData.content = '<center>' + text + '</center>'; //Token: <p>La información y documentación aportada fue recibida y nuestro departamento de validación va a comprobar que todo es correcto. Tan pronto revisemos recibirás un email para continuar con el último paso.</p><p>Nota: <i>En caso de que hubiera alguna cuestión o duda sobre la información facilitada, nuestro equipo se pondrá en contacto contigo para resolverla por email.<br/>También recibirás una notificación móvil en caso de tener la aplicación instalada.</i></p><p>Muchas gracias</p>
            });
            dialogRef = this.dialog.open(TechModalDialogComponent, {
              panelClass: this.commonService.panelClassGeneral,
              data: dialogData,
            });
            dialogRef.afterClosed().subscribe((result) => {
              window.location.replace('./login'); //Lanzo esta redireccion, y no latipica que esta mas abajo comentada, para borrar la chache del navegador
            });
            break;
          case 6: //Esperando informacion del custodio
            this.commonService.loading$.emit(false);
            this.translate.get('k002186').subscribe((text) => {
              dialogData.title = '<center>' + text + '</center>'; //Token: Recordatorio de firma de contrato
            });
            this.translate.get('k002187').subscribe((text) => {
              dialogData.content = '<center>' + text + '</center>'; //Token: <p>Tus datos han sido validados satisfactoriamente. De este modo, te hemos enviado un correo electrónico para que firmes la documentación necesaria para finalizar la apertura de tu cuenta.</p><p>Revisa la bandeja de entrada o la carpeta de SPAM. Aun así, si no encuentra o no es consciente de haber recibido  ningún correo, puedes hacer click en <i>Reenviar firma</i> y te enviaremos nuevamente el enlace necesario.</p>
            });
            this.translate.get('k002188').subscribe((text) => {
              dialogData.note = '<center>' + text + '</center>'; //Token: <p>NOTA: <i>Este mensaje aparecerá cada vez que accedas a tu área cliente hasta que hayas realizado la firma del contrato.</i></p>
            });
            this.translate.get('k002189').subscribe((text) => {
              dialogData.btoaccept = text; //Token: 'Reenviar firma'
            });
            dialogRef = this.dialog.open(TechModalDialogResendComponent, {
              panelClass: this.commonService.panelClassGeneral,
              data: dialogData,
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                //Aqui hay que meter el servicio que pide el reenvio del mail para porder firmar
                //Redirecciona al login porque no se permite hacer nada hasta que la cartera este en PRODUCTIVE
                //console.log('Reenviado');
                window.location.replace('./login'); //Lanzo esta redireccion, y no latipica que esta mas abajo comentada, para borrar la cache del navegador
              } else {
                //redirecciona al login porque no se permite hacer nada hasta que la cartera este en PRODUCTIVE
                window.location.replace('./login'); //Lanzo esta redireccion, y no latipica que esta mas abajo comentada, para borrar la cache del navegador
              }
            });
            break;
          // case '6.2':
          // case '6.3': //Cash in en marcha
          //   this.commonService.loading$.emit(false);
          //   this.translate.get('k002190').subscribe((text) => {
          //     dialogData.title = '<center>' + text + '</center>'; //Token: Ya tienes disponible tu cuenta en Inversis
          //   });
          //   this.translate.get('k002191').subscribe((text) => {
          //     dialogData.content = '<center>' + text + '</center>'; //Token: <p>Ahora debes transferir los fondos necesarios a tu nueva cuenta para comenzar a trabajar en tus finanzas personales. Una vez que los fondos lleguen a la cuenta invertiremos la cantidad acordada en la cartera modelo seleccionada anteriormente.</p><p>Muchas gracias.</p>
          //   });
          //   dialogRef = this.dialog.open(TechModalDialogComponent, {
          //     panelClass: this.commonService.panelClassGeneral,
          //     data: dialogData,
          //   });
          //   dialogRef.afterClosed().subscribe((result) => {
          //     window.location.replace('./login'); //Lanzo esta redireccion, y no latipica que esta mas abajo comentada, para borrar la chache del navegador
          //   });
          //   break;
          default:
            break;
        }
        break;
    }
  }

  private loadModalGoCashIn() {
    let dialogRef: any;
    dialogRef = this.dialog.open(ModalCashinComponent, {
      panelClass: this.commonService.panelClassGeneral,
    });
    dialogRef.afterClosed().subscribe((result) => {
      window.location.replace('./login'); //Lanzo esta redireccion, y no latipica que esta mas abajo comentada, para borrar la chache del navegador
    });
  }

  /*
  private loadCountDetails(bankdata) {
    let block;
  }
  */

  getFunding() {
    return this.completedataService
      .getFunding(localStorage.getItem('portfolioCode'))
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          this.commonService.errorManager('get_Funding', err);
          return throwError(err);
        })
      );
  }

  getPortfolioData(): Observable<PortfolioDataInterface> {
    this.portfolioCode = this.session.portfolioCode;
    return this.sdkSvc.getPortfolioData(this.portfolioCode).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.loading$.emit(false);
        this.commonService.errorManager('get_portfolioData', err);
        return throwError(err);
      })
    );
  }

  getPortfolioAnalysis(json: string): Observable<any> {
    this.loadingRiskValuations = true;
    return this.sdkSvc.getPortfolioAnalysis(json).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.isnotloading(); //Oculta el componente loading-screen
        this.commonService.errorManager('get_portfolioanalysis', err);
        return throwError(err);
      })
    );
  }

  getFixedperiods(code: string): Observable<[FixedperiodsInterfece]> {
    return this.sdkSvc.getFixedperiods(code).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.loading$.emit(false);
        this.commonService.errorManager('get_fixedperiods', err);
        return throwError(err);
      })
    );
  }

  GetPortfolioPdfUrlReport(
    portfolioCode: string,
    initialDate: string,
    endDate: string
  ): Observable<any> {
    return this.sdkSvc
      .GetPortfolioPdfUrlReport(portfolioCode, initialDate, endDate)
      .pipe(
        map((res) => {
          localStorage.setItem('SessionClientToken', this.session.sessionToken);
          return res;
        }),
        catchError((err) => {
          this.commonService.errorManager('get_portfolioPdfUrlReport', err);
          return throwError(err);
        })
      );
  }

  updatePositions() {
    if (
      this.periodSelectedSource.getValue().PeriodInitialtDate != undefined &&
      this.periodSelectedSource.getValue().PeriodEndDate != undefined
    ) {
      let jsonPortfolioAnalysis =
        '{"PortfolioCode":"' +
        this.portfolioCode +
        '", ' +
        '"InitialDate": "' +
        this.periodSelectedSource.getValue().PeriodInitialtDate +
        '",' +
        '"EndDate": "' +
        this.periodSelectedSource.getValue().PeriodEndDate +
        '",' +
        '"BenchmarkCodes": [], "Type": "Positions"}';
      this.getPortfolioAnalysis(jsonPortfolioAnalysis).subscribe((data) => {
        this.portfolioanalysisPositions$.emit(data);
        this.portfolioanalysisPositions = data;
      });
    }
  }

  updateAliasPortfolio(newAlias: string): Observable<any> {
    return this.sdkSvc.updateAliasPortfolio(newAlias).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('get_portfolioPdfUrlReport', err);
        return throwError(err);
      })
    );
  }

  getTrades() {
    if (
      this.periodSelectedSource.getValue().PeriodInitialtDate != undefined &&
      this.periodSelectedSource.getValue().PeriodEndDate != undefined
    ) {
      let jsonPortfolioAnalysis =
        '{"PortfolioCode":"' +
        this.portfolioCode +
        '", ' +
        '"InitialDate": "' +
        this.periodSelectedSource.getValue().PeriodInitialtDate +
        //this.periodSelectedSource.getValue().PeriodInitialtDate +
        '",' +
        '"EndDate": "' +
        this.periodSelectedSource.getValue().PeriodEndDate +
        //this.periodSelectedSource.getValue().PeriodEndDate +
        '",' +
        '"BenchmarkCodes": [], "Type": "Trades"}';
      this.getPortfolioAnalysis(jsonPortfolioAnalysis).subscribe((data) => {
        this.portfolioanalysisTradesSource.next(data.Trades);
      });
    }
  }

  getLiabilities() {
     if (
       this.periodSelectedSource.getValue().PeriodInitialtDate != undefined &&
       this.periodSelectedSource.getValue().PeriodEndDate != undefined
     ) {
       let jsonPortfolioAnalysis =
         '{"PortfolioCode":"' +
         this.portfolioCode +
         '", ' +
         '"InitialDate": "' +
         this.periodSelectedSource.getValue().PeriodInitialtDate +
         '",' +
         '"EndDate": "' +
         this.periodSelectedSource.getValue().PeriodEndDate +
         '",' +
         '"BenchmarkCodes": [], "Type": "Credits"}';
       this.getPortfolioAnalysis(jsonPortfolioAnalysis).subscribe((data) => {
         this.portfolioanalysisCreditsSource.next(data.Credits);
       });
     }
  }

  public getPortfolioDiscretePerformance(code: string, calcType: string, period: string) {
    return this.sdkSvc.getPortfolioDiscretePerformance(code, calcType, period).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('getPortfolioDiscretePerformance', err);
        return throwError(err);
      })
    );
  }
}
